// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

function Footer() {
  return (
    <VuiBox
      component="footer"
      py={2}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <VuiTypography
        variant="caption"
        color="white"
        fontWeight="regular"
        textAlign="center"
      >
        © {new Date().getFullYear()} – Desenvolvido por Perfecto Design & TI. Todos os direitos reservados.
      </VuiTypography>
    </VuiBox>
  );
}

export default Footer;